<template>
    <div>
        <div class="header-wrapper">
            <header class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <main class="main-box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="content-box blog">
                            <div class="content-header">
                                <h1 class="content-title">{{$t('meta.blog.h1')}}</h1>
                                <ul class="blog-nav">
                                    <li class="active"><a href="#">visi</a></li>
                                    <li><a href="#">naujienos</a></li>
                                    <li><a href="#">plėtra</a></li>
                                    <li><a href="#">kategorija</a></li>
                                </ul>
                            </div>
                            <div class="blog-wrap">
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog1.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">prieš 12 val. - naujienos</span>
                                                    <h2 class="blog-item-title">H2 Yra daug įvarių Lorem Ipsum variantų, bet daugelis jų buvo
                                                        vienokiu</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog2.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">prieš 15 val. - plėtra</span>
                                                    <h2 class="blog-item-title">H2 Kur jį gauti?</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas tekstas tekstas tekstas...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog1.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">penktadienis - naujienos</span>
                                                    <h2 class="blog-item-title">H2 Tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino
                                                        pasaulyje</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lor...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog1.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">prieš 12 val. - naujienos</span>
                                                    <h2 class="blog-item-title">H2 Yra daug įvarių Lorem Ipsum variantų, bet daugelis jų buvo
                                                        vienokiu</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog2.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">prieš 15 val. - plėtra</span>
                                                    <h2 class="blog-item-title">H2 Kur jį gauti?</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas tekstas tekstas tekstas...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blog-item">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-img">
                                                <img src="~img/blog1.png" :alt="$t('meta.blog.h1')"  :title="$t('meta.blog.h1')">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="blog-item-info">
                                                <div>
                                                    <span class="blog-item-small">penktadienis - naujienos</span>
                                                    <h2 class="blog-item-title">H2 Tai fiktyvus tekstas naudojamas spaudos ir grafinio dizaino
                                                        pasaulyje</h2>
                                                    <span class="blog-item-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lor...</span>
                                                </div>
                                                <a href="#" class="blog-item-link">skaityti toliau</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ul class="pagination-nav">
                                <li class="active"><a href="#">1</a></li>
                                <li><a href="#">2</a></li>
                                <li><a href="#">3</a></li>
                                <li><a href="#">4</a></li>
                                <li><a href="#">5</a></li>
                                <li><a href="#">6</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'Blog',
        metaInfo() {
            return {
                title: this.$t('meta.blog.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.blog.description') },
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/Blog.vue